import { render, staticRenderFns } from "./CompartirLink.vue?vue&type=template&id=58a4e3b2"
import script from "./CompartirLink.vue?vue&type=script&lang=js"
export * from "./CompartirLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports